import "./ImpressumUndDatenschutz.module.css";
import Header from "@/reusable_sections/Header";
import LegalInformationAndDataProtectionOverview from "./sections/LegalInformationAndDataProtectionOverview";
import ImprintAndCompanyDetails from "./sections/ImprintAndCompanyDetails";
import DataProtectionNotice from "./sections/DataProtectionNotice";
import Footer from "@/reusable_sections/Footer";
import SeoMeta from "./sections/SeoMeta";
export default function ImpressumUndDatenschutzPage() {
  return <div>
      <SeoMeta />
      <Header />
      <LegalInformationAndDataProtectionOverview />
      <ImprintAndCompanyDetails />
      <DataProtectionNotice />
      <Footer />
    </div>;
}